import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

const trustPoints = [
  { id: 1, icon: 'ri-shield-check-line', label: '只汇总公开流传的信息' },
  { id: 2, icon: 'ri-image-2-line', label: '画面与文字分开呈现' },
  { id: 3, icon: 'ri-refresh-line', label: '时间戳可对着顺序看' },
  { id: 4, icon: 'ri-lock-2-line', label: '不需要登录即可浏览' },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(faqItems[0].id);

  return (
    <section id="faq" className="w-full bg-secondary-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-7xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <div data-reveal>
              <span className="inline-flex items-center gap-2 rounded-full bg-secondary-500 px-3 py-1.5 text-xs font-medium text-background-50 md:text-sm">
                <i className="ri-question-answer-line" />
                <a href="#faq" className="cursor-pointer">
                  常见疑问
                </a>
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                先弄清楚，再看会更顺
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                围观之前，这几个问题问得最多。答案都写在这里，看完再往下刷会更有方向。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
              {trustPoints.map((point, index) => (
                <div
                  key={point.id}
                  data-reveal
                  data-reveal-delay={String(index * 90)}
                  className="flex items-center gap-3 rounded-lg border border-secondary-200 bg-background-50 px-4 py-3.5"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${point.icon} text-lg`} />
                  </span>
                  <span className="text-sm text-foreground-700">{point.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqItems.map((item, index) => {
                const isOpen = openId === item.id;
                return (
                  <div
                    key={item.id}
                    data-reveal
                    data-reveal-delay={String(index * 70)}
                    className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                      isOpen ? 'border-secondary-300' : 'border-background-200'
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? 0 : item.id)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left cursor-pointer md:px-6"
                    >
                      <span className="flex items-start gap-3">
                        <span className="font-heading text-sm font-bold text-secondary-600 md:text-base">
                          Q{index + 1}
                        </span>
                        <span className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                          {item.question}
                        </span>
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? 'bg-secondary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                      </span>
                    </button>
                    {isOpen && (
                      <div className="border-t border-background-200 px-5 pb-6 pt-5 md:px-6">
                        <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{item.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}